export default "__VITE_ASSET__YHuYlaPV__"